export default __webpack_public_path__ + "static/media/read.6dfffaef.png";